import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Menu, X, ShoppingBag, Heart } from 'lucide-react';
import { NAV_LINKS, SITE } from '../mock/mock';
import { useCart } from '../context/CartContext';
import { useFavorites } from '../context/FavoritesContext';

const Header = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { count } = useCart();
  const { count: favCount } = useFavorites();

  return (
    <header className="sticky top-0 z-50">
      <div className="header-gradient shadow-sm">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="flex items-center justify-between py-4">
            <Link to="/" className="flex items-center gap-4 group">
              <img
                src={SITE.logo}
                alt="Limpid Reader"
                className="h-14 w-14 lg:h-16 lg:w-16 rounded-full object-cover ring-2 ring-white/60 shadow-md transition-transform duration-500 group-hover:scale-105"
              />
              <div className="leading-tight">
                <div className="font-serif text-2xl lg:text-3xl font-bold text-brand-ink">
                  Limpid Reader
                </div>
                <div className="font-sans text-[11px] lg:text-xs tracking-luxe text-brand-brown">
                  {SITE.tagline}
                </div>
              </div>
            </Link>

            <div className="flex items-center gap-3">
              <button
                onClick={() => navigate('/favourites')}
                className="relative p-2.5 rounded-full bg-white/50 hover:bg-white text-brand-ink transition-colors duration-300"
                aria-label="My Shelf"
              >
                <Heart className="h-5 w-5" />
                {favCount > 0 && (
                  <span className="absolute -top-1 -right-1 h-5 w-5 flex items-center justify-center text-[10px] font-semibold rounded-full bg-red-500 text-white">
                    {favCount}
                  </span>
                )}
              </button>
              <button
                onClick={() => navigate('/checkout')}
                className="relative p-2.5 rounded-full bg-white/50 hover:bg-white text-brand-ink transition-colors duration-300"
                aria-label="Cart"
              >
                <ShoppingBag className="h-5 w-5" />
                {count > 0 && (
                  <span className="absolute -top-1 -right-1 h-5 w-5 flex items-center justify-center text-[10px] font-semibold rounded-full bg-brand-ink text-white">
                    {count}
                  </span>
                )}
              </button>
              <button
                className="lg:hidden p-2.5 rounded-full bg-white/50 text-brand-ink"
                onClick={() => setOpen(!open)}
                aria-label="Menu"
              >
                {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
              </button>
            </div>
          </div>

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-7 pb-3">
            {NAV_LINKS.map((link) => {
              const active = location.pathname === link.path;
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`gold-underline font-sans text-[15px] font-medium transition-colors duration-300 ${
                    active ? 'text-brand-brass' : 'text-brand-ink hover:text-brand-brass'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </nav>
        </div>
      </div>

      {/* Mobile nav */}
      {open && (
        <nav className="lg:hidden bg-cream border-b border-brand-goldlight shadow-md">
          <div className="flex flex-col py-3">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setOpen(false)}
                className={`px-6 py-3 font-sans text-base ${
                  location.pathname === link.path
                    ? 'text-brand-brass bg-sand'
                    : 'text-brand-ink'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
};

export default Header;
